// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetReferentsRequestModel from '../../model/get-referents-request-model';
import GetReferentsRequestDTO from '../dto/get-referents-request-dto';
import dtoSchema from '../schemas/get-referents-request-schema';

export default abstract class GetReferentsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetReferentsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetReferentsRequestDTO>): GetReferentsRequestModel;
  static toModel(dto: DeepPartial<GetReferentsRequestDTO> | undefined | null): GetReferentsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetReferentsRequestDTO> | undefined | null): GetReferentsRequestModel | undefined {
    return dto ? new GetReferentsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetReferentsRequestModel> | GetReferentsRequestModel): GetReferentsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      searchCriteria: unwrapped.searchCriteria,
    } as GetReferentsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetReferentsRequestModel, can not map to GetReferentsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
